/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useContext } from 'react';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';

import { useTranslation } from 'react-i18next';
import { CardContext } from '../CardContext';

export default function CardEditAction() {
  const { handleEdit } = useContext(CardContext);
  const { t } = useTranslation();

  return (
    <IconButton aria-label={t('actions.edit')} onClick={handleEdit} readOnly={!handleEdit}>
      <EditIcon />
    </IconButton>
  );
}
